export default __webpack_public_path__ + "static/media/bg-texture.46ceafde.png";